import { platformSlaSortIndex } from '@provision/service-level-utils';
/**
 * Comparator for the default (fallback) membership-plan ordering: canonical platform-SLA display
 * order first, then alphabetically by name (case-insensitive). Items without a platform SLA share
 * the last SLA index, so they group together and get ordered by name.
 */
export function comparePlatformSlaThenName(a, b) {
    return (platformSlaSortIndex(a.platformSlaId) - platformSlaSortIndex(b.platformSlaId) ||
        a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));
}
/**
 * Orders items by the partner-defined `productOrder` (partner product ids saved on the config
 * options, set via drag-and-drop), falling back to {@link comparePlatformSlaThenName} for items not
 * in that list (and for the whole list when no order is saved). Sort is stable, so equal items keep
 * their incoming order. `getKeys` reads the id and name, whose field names differ across the product
 * shapes this is shared by.
 *
 * Ordering is a presentation concern: the API returns products unordered, and each surface (the
 * portal plans tab / preview / export and the client-gateway activation flow) orders here.
 */
export const orderByProductOrder = (items, productOrder, getKeys) => {
    const orderIndexById = new Map((productOrder ?? []).map((id, index) => [id, index]));
    const orderIndexOf = (id) => orderIndexById.get(id) ?? orderIndexById.size;
    return items
        .map((item) => ({ item, platformSlaId: item.platformSlaId, ...getKeys(item) }))
        .sort((a, b) => orderIndexOf(a.id) - orderIndexOf(b.id) || comparePlatformSlaThenName(a, b))
        .map(({ item }) => item);
};
